import React, { forwardRef } from 'react';

const TransferInstructions = forwardRef(({ tabla, textoPago }, ref) => {
   return (
      <div
         ref={ref}
         id="divtransf"
         tabIndex="0"
         name="divtransf"
         className="mt-5 border border-[#E6D8C9] bg-[#FBF7F2] p-5 text-[#6B4A2A] outline-none transition-colors focus:border-[#9B6D3F]"
      >
         <p className="mb-2 text-[0.68rem] uppercase tracking-[0.18em] text-[#9B6D3F]">
            Transferencia bancaria
         </p>
         <h4
            className="mb-3 text-xl font-medium text-[#1A1A1A]"
            style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
         >
            Instrucciones de pago
         </h4>
         <p className="mb-3 text-sm leading-relaxed text-[#7A7570]">
            Realice la transferencia a la siguiente cuenta y conserve el comprobante.
         </p>
         <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed text-[#6B4A2A]">
            {tabla.length >= 4 && (
               <>
                  <li className="break-words">
                     {tabla[0]?.descripcion}
                  </li>
                  <li className="break-words">
                     {tabla[1]?.descripcion}
                  </li>
                  <li className="break-words">
                     {tabla[2]?.descripcion}
                  </li>
                  <li className="break-words">
                     {tabla[3]?.descripcion}
                  </li>
               </>
            )}
         </ul>
         <p className="mt-4 text-sm leading-relaxed text-[#7A7570]">
            Incluya su nombre y número de pedido en la referencia de la transferencia.
         </p>
         <p className="mt-2 text-sm leading-relaxed text-[#7A7570]">
            Después haga click en {textoPago} y envíe el comprobante a{" "}
            <b>{tabla[4]?.descripcion}</b>
         </p>
      </div>
   );
});

// Add display name for debugging
TransferInstructions.displayName = 'TransferInstructions';

export default TransferInstructions;